import cloneDeep from 'lodash/fp/cloneDeep'
import { listDifferenceComputer } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
import {
  START_EDITING_PENDING_APPROVAL_LANGUAGES
  , STOP_EDITING_PENDING_APPROVAL_LANGUAGES
  , CANCEL_EDITING_PENDING_APPROVAL_LANGUAGES
  , PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_FETCHED_LANGUAGES
  , PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_LANGUAGE_SELECTED_CHANGED
} from './adviserProfileLanguagePreferencesEditorActions'

import { validiateChecklistField } from '../../../../../common/forms/validationFunctions'

import { events as containerEvents } from '../../AdviserProfileApprovalEditorContainer/adviserProfileApprovalEditorContainerActions'

const initialState = {
  loadingLanguages: false,
  editingLanguages: false,
  languagePreferencesBeforeEditing: [],
  allLanguages: [],
  isInvalid: {
    formIsValid: true,
    languages: {
      isInvalid: false,
      message: null
    }
  },
  profileModifications: []
}

const minimumRequiredSelection = 1

export default function (state = initialState, action) {
  var newState = copyLanguagePreferencesState(state)
  switch (action.type) {
    case containerEvents.fetch.fetched:
      newState.languagePreferences.profileModifications = findLanguagePreferenceDifferences(newState)
      return newState
    case START_EDITING_PENDING_APPROVAL_LANGUAGES:
      newState.languagePreferences.editingLanguages = true
      newState.languagePreferencesBeforeEditing = newState.pendingApprovalProfile.languagePreferences
      newState.languagePreferences.isInvalid.languages = validiateChecklistField(newState.pendingApprovalProfile.languagePreferences, minimumRequiredSelection)
      newState.languagePreferences.isInvalid.formIsValid = formIsValid(newState.languagePreferences.isInvalid)
      return newState
    case STOP_EDITING_PENDING_APPROVAL_LANGUAGES:
      newState.languagePreferences.editingLanguages = false
      return newState
    case CANCEL_EDITING_PENDING_APPROVAL_LANGUAGES:
      newState.languagePreferences.editingLanguages = false
      newState.pendingApprovalProfile.languagePreferences = cloneDeep(newState.languagePreferencesBeforeEditing)
      newState.languagePreferencesBeforeEditing = []
      newState.languagePreferences.profileModifications = findLanguagePreferenceDifferences(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_FETCHED_LANGUAGES:
      newState.languagePreferences.allLanguages = action.payload
      return newState
    case PENDING_APPROVAL_ADVISER_LANGUAGE_PREFERENCES_LANGUAGE_SELECTED_CHANGED:
      const selectedLanguages = newState.pendingApprovalProfile.languagePreferences || []

      const exists = selectedLanguages.some(
        (language) => language.languageId === action.language.languageId
      )

      const updatedLanguages = exists
        ? selectedLanguages.filter(
          (language) => language.languageId !== action.language.languageId
        )
        : [...selectedLanguages, action.language]

      newState.pendingApprovalProfile.languagePreferences = updatedLanguages

      newState.languagePreferences.isInvalid.languages = validiateChecklistField(updatedLanguages, minimumRequiredSelection)
      newState.languagePreferences.isInvalid.formIsValid = formIsValid(newState.languagePreferences.isInvalid)
      newState.languagePreferences.profileModifications = findLanguagePreferenceDifferences(newState)
      newState.edited = true
      return newState
  }
  return state
}

function copyLanguagePreferencesState (state) {
  var newState = cloneDeep(state)
  newState.pendingApprovalProfile = cloneDeep(state.pendingApprovalProfile)
  if (state.pendingApprovalProfile) {
    newState.pendingApprovalProfile.languagePreferences = cloneDeep(state.pendingApprovalProfile.languagePreferences)
  }
  return newState
}

function formIsValid (isInvalid) {
  return !isInvalid.languages.isInvalid
}

function findLanguagePreferenceDifferences (state) {
  var oldList = state.publishedProfile.languagePreferences
  var newList = state.pendingApprovalProfile.languagePreferences
  return listDifferenceComputer(oldList, newList, 'languageId')
}
